import React from 'react';
import { Row, Col } from 'antd';
import { Title } from '@/components/Typography';
import { InformativeTable } from './InformativeTable';
import { SeriousRiskTable } from './SeriousRiskTable';
import { PercentageBarRisk } from './PercentageBarRisk';
import { ActivityRiskResult } from '@/core/domain/owas-report';
import * as S from './styles';

interface ActivityRiskProps {
	data: ActivityRiskResult;
}

export function ActivityRisk({ data }: Readonly<ActivityRiskProps>): JSX.Element {
	return (
		<Row>
			<Col span={24}>
				<Row gutter={[0, 10]}>
					<Col span={24}>
						<Title level={2}>Overall task risk</Title>
					</Col>
					<S.Content span={24}>
						<PercentageBarRisk percentage={data.percentage} />
					</S.Content>
				</Row>
				<Row gutter={[0, 10]}>
					<S.Content span={24}>
						<InformativeTable />
					</S.Content>
				</Row>
				<Row gutter={[0, 10]}>
					<S.Content span={24} style={{ marginTop: '2rem' }}>
						<Title level={4}>Tasks with the most serious risks</Title>
					</S.Content>
					<S.Content span={24}>
						<SeriousRiskTable data={data.most_serious_risk_tasks} />
					</S.Content>
				</Row>
			</Col>
		</Row>
	);
}
